import React, { useEffect, useState } from "react";
import AlertField from "../Components/AlertField";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";
import moment from "moment-timezone";

const Notification = () => {
  const [notification, setNotification] = useState();
  const [alert, setAlert] = useState();
  const axiosPrivate = useAxiosPrivate();

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  useEffect(() => {
    const fetchNotification = async () => {
      try {
        const response = await axiosPrivate.get("notification/view/");
        setNotification(response?.data);
      } catch (err) {
        if (!err?.response) {
          showAlert("No Server Response", "warning");
        } else {
          showAlert("Load Failed", "warning");
        }
      }
    };
    fetchNotification();
  }, []);

  const onClick = async (id, link) => {
    try {
      await axiosPrivate.put(`notification/read/${id}/`);

      window.location.href = link;
    } catch (err) {
      if (!err?.response) {
        showAlert("No Server Response", "warning");
      } else {
        showAlert("Update Failed", "warning");
      }
    }
  };

  return (
    <>
      <AlertField alert={alert} />
      <div className="mx-3 mx-md-5">
        <h2 className="my-3 text-center">Notifications</h2>
        <div className="table-responsive">
          <table className="w-auto m-auto table bg-light table-striped table-hover">
            <thead>
              <tr>
                <th className="w-25">S.No.</th>
                <th>Info</th>
                <th className="w-25">Date / Time</th>
              </tr>
            </thead>
            <tbody>
              {notification?.length > 0 ? (
                notification.map((notif, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>
                      <button
                        className="btn btn-link text-decoration-none p-0"
                        onClick={() => onClick(notif.id, notif.link)}
                      >
                        {notif.message}
                      </button>
                    </td>
                    <td>
                      {moment
                        .tz(notif.created_at, "Asia/Kathmandu")
                        .format("YYYY-MM-DD hh:mm A")}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3} className="text-center">
                    No New Notification
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Notification;
